import script from "./AiCallModal.vue?vue&type=script&setup=true&lang=ts"
export * from "./AiCallModal.vue?vue&type=script&setup=true&lang=ts"

import "./AiCallModal.vue?vue&type=style&index=0&id=0e22a6a2&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-0e22a6a2"]])

export default __exports__